export default __webpack_public_path__ + "static/sportspullen-6cc92953de0ba214a53559c16f2a7e4e.png";